import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        addShift: builder.mutation({
            query: (body) => ({
                url: `schedule/addShift`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllShift: builder.mutation({
            query: (body) => ({
                url: `schedule/getAllShift`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getShiftById: builder.mutation({
            query: (body) => ({
                url: `schedule/getShiftById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateShift: builder.mutation({
            query: (body) => ({
                url: `schedule/updateShift`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        })
    })
})

export const { useAddShiftMutation, useGetAllShiftMutation, useGetShiftByIdMutation, useUpdateShiftMutation } = Api
